var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKitsGraphicsCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "0c5d48c95e"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "977e8fd2f8"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#0c5d48c95e)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#000000",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 0.749
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "58ff1ba5f2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2 0.160156 L 363.878906 0.160156 L 363.878906 347 L 2 347 Z M 2 0.160156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5914dbc899"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 364,
    y: 0,
    height: 348
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#977e8fd2f8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 5, 14)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5914dbc899)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#58ff1ba5f2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2b342c",
    d: "M 363.683594 172.765625 C 363.667969 182.042969 363.054688 191.308594 361.8125 200.503906 C 356.890625 236.972656 341.96875 272.554688 316.664062 299.609375 C 290.34375 327.75 254.164062 343.8125 215.832031 346.207031 C 195.539062 347.476562 175.195312 344.835938 155.222656 341.398438 C 137.957031 338.429688 120.820312 334.367188 104.335938 328.394531 C 74.15625 317.464844 46.484375 299.589844 28.378906 272.617188 C 18.605469 258.054688 11.980469 241.566406 7.957031 224.542969 C 3.136719 204.125 1.378906 182.457031 2.796875 161.527344 C 5.488281 121.851562 22.777344 84.195312 50.390625 55.660156 C 78.59375 26.519531 116.570312 7.628906 156.703125 2.058594 C 175.574219 -0.558594 194.847656 -0.164062 213.789062 1.523438 C 230.09375 2.972656 246.347656 5.71875 262.003906 10.554688 C 291.296875 19.601562 317.636719 36.496094 335.214844 61.941406 C 357.429688 94.089844 363.640625 134.480469 363.683594 172.765625 Z M 363.683594 172.765625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitsGraphicsCircle);
export default __webpack_public_path__ + "static/media/kits_graphics_circle.7ed2e198916e2979af2a12f7412c8d6f.svg";
export { ForwardRef as ReactComponent };